export const INDUSTRIES = [
  { value: "textile_garment", label: "Textile & Garment Mills", key: "textiles" },
  { value: "manufacturing_electronics", label: "Manufacturing & Electronics (AC/Appliances)", key: "factories" },
  { value: "malls_retail", label: "Shopping Malls & Retail Chains", key: "malls" },
  { value: "multiplex_cinema", label: "Multiplexes & Cinema Theatres", key: "multiplex" },
  { value: "construction_infra", label: "Construction & Infrastructure", key: "construction" },
  { value: "warehousing_logistics", label: "Warehousing & Logistics", key: "warehousing" },
];

export const SERVICE_TYPES = [
  { value: "security", label: "Security Services" },
  { value: "skilled", label: "Skilled Labour" },
  { value: "unskilled", label: "Unskilled Labour" },
];

export const SHIFTS = [
  { value: "day", label: "Day Shift" },
  { value: "night", label: "Night Shift" },
  { value: "8_hour", label: "8-Hour" },
  { value: "12_hour", label: "12-Hour" },
  { value: "rotational", label: "Rotational" },
];

export const FACILITIES = [
  { value: "pf_esic", label: "PF & ESIC", id: "pf-esic" },
  { value: "food", label: "Free Food / Canteen", id: "food" },
  { value: "accommodation", label: "Room / Accommodation", id: "accommodation" },
  { value: "transport", label: "Transport (Bus/Cab)", id: "transport" },
  { value: "uniform", label: "Uniform & Safety Kit", id: "uniform" },
];

export const GENDER = [{ value: "male", label: "Male" }, { value: "female", label: "Female" }];
export const MARITAL = [{ value: "unmarried", label: "Unmarried" }, { value: "married", label: "Married" }];

export const RELOCATION = [
  { value: "within_district", label: "Within District" },
  { value: "within_state", label: "Within State" },
  { value: "all_india", label: "All India" },
];

export const SKILLS = [
  { value: "security", label: "Security Guard / Bouncer / Supervisor" },
  { value: "factory_skilled", label: "Factory Employee / Machine Operator / Skilled Technician" },
  { value: "mall_cinema_staff", label: "Mall / Cinema Staff (Housekeeping, Usher, Helpers)" },
];
